import React, { Component } from 'react';
import API from '../api.js';
import Tools from '../tools';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';

class Header extends Component {
    constructor() {
        super();
        Tools.init();
        // this.state = {
        //     isAdmin: API.getIsAdmin()
        // }
        this.logout = this.logout.bind(this);
    }

    logout() {
        API.Logout()
            .then((data => {
                this.props.history.push(API.login_page);
                // console.log(API.first_page, data);

                // if (!data || !data.code
                // 	|| (22040 != data.code && 22042 != data.code)
                // ) {
                // 	//error
                // 	alert("請確認帳密");
                // } else {
                // 	this.props.history.push(API.first_page);
                // }
            }).bind(this)) // JSON from `response.json()` call
            .catch((error => {
                console.warn(error);
                this.props.history.push(API.login_page);
            }).bind(this))
    }

    render() {
        const tmp = "/#/";
        const { logout } = this;
        // const { isAdmin } = this.state;

        return (
            <>
                <Navbar sticky="top" collapseOnSelect expand="md" bg="dark" variant="dark">
                    <Navbar.Brand href={tmp + "index"}>EZC</Navbar.Brand>
                    <br />
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="mr-auto">
                            {/* <!-- 會員 --> */}
                            {/* {isAdmin ? ( */}
                            <NavDropdown title="會員" id="collasible-nav-dropdown-mem">
                                <NavDropdown.Item href={tmp + "member/index"}>列表</NavDropdown.Item>
                            </NavDropdown>
                            {/* ) : null} */}

                            {/* <!-- 專案 --> */}
                            <NavDropdown title="專案" id="collasible-nav-dropdown-proj">
                                <NavDropdown.Item href={tmp + "proj/index"}>列表</NavDropdown.Item>
                                <NavDropdown.Item href={tmp + "proj/add"}>建立專案</NavDropdown.Item>
                            </NavDropdown>

                            {/* <!-- 禮物 --> */}
                            {/* {isAdmin ? ( */}
                            <NavDropdown title="禮物" id="collasible-nav-dropdown-goods">
                                <NavDropdown.Item href={tmp + "goods/create"}>新增</NavDropdown.Item>
                                <NavDropdown.Item href={tmp + "goods/index"}>列表</NavDropdown.Item>
                            </NavDropdown>
                            {/* ) : null} */}

                            {/* <!-- 廣告 --> */}
                            {/* {isAdmin ? ( */}
                            <NavDropdown title="廣告" id="collasible-nav-dropdown-ads">
                                <NavDropdown.Item href={tmp + "ads/create"}>新增</NavDropdown.Item>
                                <NavDropdown.Item href={tmp + "ads/index"}>列表</NavDropdown.Item>
                            </NavDropdown>
                            {/* ) : null} */}

                            {/* <!-- Notice --> */}
                            {/* <NavDropdown title="Notice" id="collasible-nav-dropdown-notice">
                                <NavDropdown.Item disabled href="#send_notify">
                                    <Link to={tmp + "send_notify"}>設置橫幅廣告</Link>
                                </NavDropdown.Item>
                                <NavDropdown.Item>
                                    <Link to={tmp + "send_main"}>將問卷、廣告專案推送給會員</Link>
                                </NavDropdown.Item>
                            </NavDropdown> */}

                            {/* <!-- 後台管理 --> */}
                            {/* <NavDropdown title="後台管理" id="collasible-nav-dropdown-bkstg">
                                <NavDropdown.Item disabled href="#send_notify">
                                    <Link>新增管理者 沒API????</Link>
                                </NavDropdown.Item>
                                <NavDropdown.Item disabled href="#send_notify">
                                    <Link>管理者 list 沒API????</Link>
                                </NavDropdown.Item>
                                <NavDropdown.Item disabled href="#send_notify">
                                    <Link>管理者資料 沒API????</Link>
                                </NavDropdown.Item>
                                <NavDropdown.Item disabled href="#send_notify">
                                    <Link>下載報表 沒API????</Link>
                                </NavDropdown.Item>
                            </NavDropdown> */}

                            {/* <!-- 客戶管理 --> */}
                            {/* <NavDropdown title="客戶管理" id="collasible-nav-dropdown-customer">
                                <NavDropdown.Item disabled href="#send_notify">
                                    <Link>新增客戶 沒API????</Link>
                                </NavDropdown.Item>
                                <NavDropdown.Item disabled href="#send_notify">
                                    <Link>客戶 list 沒API????</Link>
                                </NavDropdown.Item>
                                <NavDropdown.Item disabled href="#send_notify">
                                    <Link>客戶資料 沒API????</Link>
                                </NavDropdown.Item>
                            </NavDropdown> */}

                            {/* <!-- 設置橫幅廣告 --> */}
                            {/* <NavDropdown title="設置橫幅廣告" id="collasible-nav-dropdown-banner">
                                <NavDropdown.Item>
                                    <Link to={tmp + "update_banner"}>設置橫幅廣告</Link>
                                </NavDropdown.Item>
                            </NavDropdown> */}

                            {/* <!-- 問卷 --> */}
                            {/* <NavDropdown title="問卷" id="collasible-nav-dropdown-quest">
                                <NavDropdown.Item>
                                    <Link to={tmp + "add_quest"}>新增/修改</Link>
                                </NavDropdown.Item>
                                <NavDropdown.Item>
                                    <Link to={tmp + "quest"}>列表</Link>
                                </NavDropdown.Item>
                            </NavDropdown> */}

                            {/* <!-- 功能 --> */}
                            {/* <NavDropdown title="功能" id="collasible-nav-dropdown-func">
                                <NavDropdown.Item onClick={logout}><Link>登出</Link></NavDropdown.Item>
                            </NavDropdown> */}
                        </Nav>
                    </Navbar.Collapse>
                    <Navbar.Collapse className="justify-content-end">
                        {/* <Navbar.Text>{"XXXXX您好"}</Navbar.Text> */}
                        <Nav.Link onClick={logout}>登出</Nav.Link>
                    </Navbar.Collapse>
                </Navbar>

            </>
        );
    }
}

const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header)